import React from 'react';
import { Dialog } from '@headlessui/react';
import { SchedaTecnica } from '../types/SchedaTecnica';
import List from './List';
import PrimaryButtonSm from './PrimaryButtonSm';
import { validateSchedaTecnica } from '../lib/utils/validation';

interface Props {
  data?: SchedaTecnica;
}

// eslint-disable-next-line react/function-component-definition
const SchedaTecnicaList: React.FC<Props> = ({ data }) => (
  <div className="flex flex-col text-left px-4 max-h-[70vh] overflow-y-auto">
    <List title="Macchine utensili" subtitle="Centri lavoro CNC" items={data?.macchine_utensili.centri_lavoro_cnc} />
    <List subtitle="Torni" items={data?.macchine_utensili.torni.torni} />
    <div className="flex flex-col sm:flex-row sm:gap-8">
      <List subtitle="Numero assi" items={data?.macchine_utensili.torni.nr_assi_torni} sublist />
      <List subtitle="Tipo di tornitura automatica" items={data?.macchine_utensili.torni.tipo_tornitura} sublist />
    </div>
    <List subtitle="Fresatrici" items={data?.macchine_utensili.fresatrici.fresatrici} />
    <div className="flex flex-col sm:flex-row sm:gap-8">
      <List subtitle="Frese in base alla lavorazione" items={data?.macchine_utensili.fresatrici.tipi_frese} sublist />
      <List subtitle="Numero assi" items={data?.macchine_utensili.fresatrici.nr_assi_frese} sublist />
    </div>
    {data?.macchine_utensili.trapani_colonna && (
      <h5 className="text-sm text-left font-primarybold text-textgrey mb-2">Trapani a colonna</h5>
    )}
    {data?.macchine_utensili.macchine_transfer && (
      <h5 className="text-sm text-left font-primarybold text-textgrey mb-2">Macchine transfer</h5>
    )}
    {data?.macchine_utensili.macchine_maschiatrici && (
      <h5 className="text-sm text-left font-primarybold text-textgrey mb-2">Macchine maschiatrici</h5>
    )}
    {data?.macchine_utensili.presse_piegatrici && (
      <h5 className="text-sm text-left font-primarybold text-textgrey mb-2">Presse piegatrici</h5>
    )}
    {data?.macchine_utensili.taglio_lamiera && (
      <h5 className="text-sm text-left font-primarybold text-textgrey mb-2">Macchine per il taglio lamiera</h5>
    )}
    {data?.macchine_utensili?.extra && (
      <div className="flex items-baseline">
        <h5 className="text-sm text-left font-primarybold text-textgrey mb-2">Altro:&nbsp;</h5>
        <span className="list-none text-xs">{data.macchine_utensili.extra}</span>
      </div>
    )}
    {data?.disegno_meccanico?.tipo?.includes('altro') && (
      <h4 className="text-sm text-left font-primarybold text-black mb-2">Disegno Meccanico</h4>
    )}
    {data?.disegno_meccanico?.tipo && !data?.disegno_meccanico?.tipo?.includes('altro') && (
      <List title="Disegno Meccanico" items={data?.disegno_meccanico?.tipo} />
    )}
    {data?.disegno_meccanico?.extra && (
      <div className="flex items-baseline">
        <h5 className="text-sm text-left font-primarybold text-textgrey mb-2">Altro:&nbsp;</h5>
        <span className="list-none text-xs">{data.disegno_meccanico?.extra}</span>
      </div>
    )}
    {data?.disegno_tecnico?.tipo === 'Si' && (
      <h4 className="text-sm text-left font-primarybold text-black mb-2">Disegno Tecnico</h4>
    )}
    {data?.disegno_tecnico?.extra && (
      <div className="flex items-baseline">
        <h4 className="text-sm text-left font-primarybold text-textgrey mb-2">Altro:&nbsp;</h4>
        <span className="list-none text-xs">{data.disegno_tecnico?.extra}</span>
      </div>
    )}
    <List title="Rettifica" items={data?.rettifica} />
    <List title="Saldatura" items={data?.saldatura?.tipi} extra={data?.saldatura?.extra} />
    <List title="Trattamenti galvanici nel settore industriale" items={data?.trattamenti_galvanici} />
    <List title="Stampaggio Industriale" items={data?.stampaggio?.stampaggio} />
    {data?.stampaggio?.macchine && <List subtitle="Macchine da stampa" items={data?.stampaggio?.macchine} />}
    <List title="Assemblaggio" items={data?.assemblaggio} />
    <List title="Montaggio" items={data?.montaggio} />
    <List title="Linguaggi di programmazione per PLC" items={data?.linguaggi_programmazione_plc} />
    <List title="Sistema CNC" items={data?.sistema_cnc.sistemi} extra={data?.sistema_cnc?.extra} />
    <List title="Ingegneria" items={data?.ingegneria?.tipo} extra={data?.ingegneria?.extra} />
    <List
      title="Linguaggi di programmazione"
      items={data?.linguaggi_programmazione?.linguaggi}
      extra={data?.linguaggi_programmazione?.extra}
    />
    <List
      title="Linguaggi di progettazione"
      items={data?.linguaggi_progettazione?.linguaggi}
      extra={data?.linguaggi_progettazione?.extra}
    />    
    <List title="Sistemi operativi" items={data?.sistemi_operativi} />
    <List title="Software per la Produttività" />
    {data?.software_produttivita?.microsoft && (
      <List subtitle="Microsoft Office Suite" items={data?.software_produttivita?.microsoft} />
    )}
   {data?.software_produttivita?.google && (
      <List subtitle="Google Workspace" items={data?.software_produttivita?.google} />
    )}
    {data?.software_produttivita?.fogli_calcolo && (
      <List subtitle="Gestione di fogli di calcolo" items={data?.software_produttivita?.fogli_calcolo} />
    )}
     {data?.software_produttivita?.presentazioni && (
      <List subtitle="Creazione di presentazioni" items={data?.software_produttivita?.presentazioni} />
    )} 

    <List title="Navigazione in Internet" />
    {data?.navigazione_internet?.motori_ricerca && (
      <List
        subtitle="Motori di ricerca"
        items={data?.navigazione_internet?.motori_ricerca?.tipo}
        extra={data?.navigazione_internet?.motori_ricerca?.extra}
      />
    )} 
     {data?.navigazione_internet?.browser && (
      <List
        subtitle="Browser"
        items={data?.navigazione_internet?.browser?.tipo}
        extra={data?.navigazione_internet?.browser?.extra}
      />
    )}
    {data?.navigazione_internet?.email && (
      <List
        subtitle="Utilizzo di email"
        items={data?.navigazione_internet?.email?.tipo}
        extra={data?.navigazione_internet?.email?.extra}
      />
    )}
    <List title="Strumenti di comunicazione" items={data?.strumenti_comunicazione} />
    <List title="Gestione di database" />
     {data?.gestione_database?.db_relazionali && (
      <List
        subtitle="Database relazionali"
        items={data?.gestione_database?.db_relazionali?.tipo}
        extra={data?.gestione_database?.db_relazionali?.extra}
      />
    )} 
     {data?.gestione_database?.strumenti_gestione && (
      <List
        subtitle="Strumenti di gestione"
        items={data?.gestione_database?.strumenti_gestione?.tipo}
        extra={data?.gestione_database?.strumenti_gestione?.extra}
      />
    )}
    {data?.gestione_database?.db_no_relazionali && (
      <List subtitle="Database no-relazionali" items={data?.gestione_database?.db_no_relazionali} />
    )} 

    <List title="Grafica e multimedia" items={data?.grafica_multimedia?.grafica_multimedia} />
    {data?.grafica_multimedia?.montaggio_video && (
      <List
        subtitle="Montaggio video"
        items={data?.grafica_multimedia?.montaggio_video?.tipo}
        extra={data?.grafica_multimedia?.montaggio_video?.extra}
      />
    )}

    <List title="Sviluppo web" items={data?.sviluppo_web?.sviluppo_web} />
    {data?.sviluppo_web?.cms && (
      <List subtitle="CMS" items={data?.sviluppo_web?.cms?.tipo} extra={data?.sviluppo_web?.cms?.extra} />
    )}

    <List title="Analisi dei dati" />
    {data?.analisi_dati?.strumenti_analisi && (
      <List
        subtitle="Strumenti di analisi"
        items={data?.analisi_dati?.strumenti_analisi?.tipo}
        extra={data?.analisi_dati?.strumenti_analisi?.extra}
      />
    )}
    {data?.analisi_dati?.linguaggi_analisi && (
      <List subtitle="Linguaggi per l'analisi" items={data?.analisi_dati?.linguaggi_analisi} />
    )}
    <List title="Sicurezza Informatica" items={data?.sicurezza_informatica} />
     <List
      title="Intelligenza Artificiale"
      items={data?.intelligenza_artificiale?.intelligenza_artificiale}
      extra={data?.intelligenza_artificiale?.extra}
    /> 
    <List
      title="Sistemi meccatronici"
      items={data?.sistemi_meccatronici?.sistemi}
      extra={data?.sistemi_meccatronici?.extra}
    />

    <List title="Altri macchinari industriali" items={data?.altri_macchinari_industriali} />
    <List title="Strumenti di precisione" items={data?.strumenti_precisione} />
    <List
      title="Apparecchiature di produzione LCD e semiconduttori"
      items={data?.apparecchiature_produzione_lcd_semi}
    />
    <List title="Robot industriali" items={data?.robot_industriali} />
    <List title="Dispositivi elettronici" items={data?.dispositivi_elettronici} />

    <List title="Impianti elettrici" items={data?.impianti_elettrici?.impianti_elettrici} />
    {data?.impianti_elettrici?.competenze && (
      <List subtitle="Competenze specifiche" items={data?.impianti_elettrici?.competenze} />
    )}
    {data?.impianti_elettrici?.attestato && <List subtitle="Attestato" items={data?.impianti_elettrici?.attestato} />}

    <List title="Autotrasporto" items={data?.autotrasporto?.autotrasporto} />
    {data?.autotrasporto?.tipo_patente && (
      <div className="flex items-baseline">
        <h4 className="text-sm text-left font-primarybold text-textgrey mb-2">Tipo di patente:&nbsp;</h4>
        <span className="list-none text-xs">{data.autotrasporto?.tipo_patente}</span>
      </div>
    )}
    {data?.autotrasporto?.tipo_merci && (
      <div className="flex items-baseline">
        <h4 className="text-sm text-left font-primarybold text-textgrey mb-2">Tipologia merci:&nbsp;</h4>
        <span className="list-none text-xs">{data.autotrasporto?.tipo_merci}</span>
      </div>
    )}
     {data?.autotrasporto?.tipo_veicoli && (
      <div className="flex items-baseline">
        <List
          subtitle="Tipologia di veicoli utilizzati"
          items={data?.autotrasporto?.tipo_veicoli?.tipo_veicoli?.tipo}
          extra={data?.autotrasporto?.tipo_veicoli?.tipo_veicoli?.extra}
        />
      </div>
    )} 
    {data?.autotrasporto?.tipo_veicoli?.categoria && (
      <List subtitle="Categoria Autocarri" items={data?.autotrasporto?.tipo_veicoli?.categoria} />
    )}

    <List
      title="Cantieristica navale"
      items={data?.cantieristica_navale?.cantieristica_navale?.tipo}
      extra={data?.cantieristica_navale?.cantieristica_navale?.extra}
    />
    {data?.cantieristica_navale?.tipologia && (
      <List subtitle="Tipologia" items={data?.cantieristica_navale?.tipologia} />
    )} 
    {data?.cantieristica_navale?.classificazione && (
      <List subtitle="Classificazione" items={data?.cantieristica_navale?.classificazione} />
    )}

    <List title="Officina meccanica delle riparazioni" items={data?.meccatronica_officina?.meccatronica_officina} />
    {data?.meccatronica_officina?.competenze && (
      <List subtitle="Competenze specifiche" items={data?.meccatronica_officina?.competenze} />
    )}

    <List title="Verniciatura industriale" items={data?.verniciatura?.verniciatura} extra={data?.verniciatura?.extra} />
  </div>
);

interface DialogProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  data: SchedaTecnica;
}

function SchedaTecnicaRecap({ title, isOpen, onClose, data }: DialogProps) {
  return (
    <Dialog className="relative z-50" open={isOpen} onClose={onClose}>
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-2xl rounded-xl bg-white p-4 text-center">
          <Dialog.Title as="h3" className="font-primarybold mb-3 text-primary">
            {title}
          </Dialog.Title>
          {!validateSchedaTecnica(data) ? (
            <SchedaTecnicaList data={data} />
          ) : (
            <p className="text-sm text-textgrey">
            Non sono stati forniti ulteriori dati.
            </p>
          )}
          <div className="flex justify-center mt-4">
            <PrimaryButtonSm text="Chiudi" onClick={onClose} />
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default SchedaTecnicaRecap;
